/* eslint-disable max-classes-per-file */
export class DirectScheduleEvent {
  id: number;
  locationId: number;
  patientId: number;
  personaClientId: number;
  startTime: Date;
  endTime: Date;
  location: SessionLocation;
  clientFirstName: string;
  clientFullName: string;
  clientInitials: string;
  providerFirstName: string;
  providerFullName: string;
  providerInitials: string;
  sessionType: string;
  ncrFreeText: string;
  ncrReasons: string;

  constructor(json: IDirectScheduleEventResponse) {
    this.id = json.id;
    this.locationId = json.location_id;
    this.patientId = json.patient_id;
    this.personaClientId = json.persona_client_id;
    this.startTime = new Date(json.start_time);
    this.endTime = this.addOneMinute(json.end_time);
    this.clientFirstName = json.client_first_name;
    this.clientFullName = json.client_full_name;
    this.clientInitials = json.client_initials;
    this.providerFirstName = json.provider_first_name;
    this.providerFullName = json.provider_full_name;
    this.providerInitials = json.provider_initials;
    this.sessionType = json.session_type;
    this.ncrFreeText = json.ncr_free_text;
    this.ncrReasons = json.ncr_reasons;
    if (json.location) {
      this.location = new SessionLocation(json.location);
    }
  }

  addOneMinute(d) {
    const returnDate = new Date(d);
    returnDate.setMinutes(returnDate.getMinutes() + 1);
    return returnDate;
  }
}
export interface IDirectScheduleEventResponse {
  id: number;
  location_id: number;
  patient_id: number;
  persona_client_id: number;
  start_time: string;
  end_time: string;
  location: ISessionLocationResponse;
  client_first_name: string;
  client_full_name: string;
  client_initials: string;
  provider_first_name: string;
  provider_full_name: string;
  provider_initials: string;
  session_type: string;
  ncr_free_text: string;
  ncr_reasons: string;
}
export class SessionLocation {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postalCode: string;
  constructor(json: ISessionLocationResponse) {
    this.addressLine1 = json.address_line1;
    this.addressLine2 = json.address_line2;
    this.city = json.city;
    this.state = json.state;
    this.postalCode = json.postal_code;
  }
}
export interface ISessionLocationResponse {
  address_line1: string;
  address_line2: string;
  city: string;
  state: string;
  postal_code: string;
}
